import messages from '../locale/en.json';
export const defaultMessages = messages.en;
